var map = {
	"./bbishop.png": 9247,
	"./bking.png": 981,
	"./bknight.png": 371,
	"./bpawn.png": 8630,
	"./bqueen.png": 6012,
	"./brook.png": 5599,
	"./wbishop.png": 6110,
	"./wking.png": 212,
	"./wknight.png": 3818,
	"./wpawn.png": 1347,
	"./wqueen.png": 6919,
	"./wrook.png": 8278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6211;